import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=e53120c8&scoped=true&"
import script from "./retail.vue?vue&type=script&lang=js&"
export * from "./retail.vue?vue&type=script&lang=js&"
import style0 from "./retail.vue?vue&type=style&index=0&id=e53120c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53120c8",
  null
  
)

export default component.exports